<script lang="ts">
  import { onMount } from 'svelte';
  import { api, unwrap } from '../lib/api';
  type PublicMetaConfig = { enabled: boolean; pixelId: string | null; browserPixelEnabled: boolean; messengerUrl: string | null };
  let config = $state<PublicMetaConfig | null>(null);
  let choice = $state<string | null>(localStorage.getItem('bibow.marketing-consent'));

  function loadPixel(pixelId: string) {
    if (document.querySelector('script[data-bibow-meta-pixel]')) return;
    const w = window as unknown as { fbq?: (...args: unknown[]) => void; _fbq?: unknown };
    const fbq = function(...args: unknown[]) {
      const queue = (fbq as unknown as { queue?: unknown[][] }).queue ??= [];
      queue.push(args);
    } as unknown as (...args: unknown[]) => void;
    (fbq as unknown as { loaded?: boolean; version?: string; queue?: unknown[][] }).loaded = true;
    (fbq as unknown as { loaded?: boolean; version?: string; queue?: unknown[][] }).version = '2.0';
    w.fbq = w.fbq || fbq;
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    script.dataset.bibowMetaPixel = 'true';
    document.head.appendChild(script);
    w.fbq?.('init', pixelId);
    w.fbq?.('track', 'PageView');
  }

  function choose(value: 'yes' | 'no') {
    choice = value;
    localStorage.setItem('bibow.marketing-consent', value);
    if (value === 'yes' && config?.enabled && config.browserPixelEnabled && config.pixelId) loadPixel(config.pixelId);
  }

  onMount(async () => {
    try {
      const res = await api.api.v1.integrations.meta.$get();
      config = await unwrap<PublicMetaConfig>(res);
      if (choice === 'yes' && config.enabled && config.browserPixelEnabled && config.pixelId) loadPixel(config.pixelId);
    } catch { config = null; }
  });
</script>
{#if config?.enabled && config.browserPixelEnabled && config.pixelId && !choice}
  <div class="consent-banner shadow-lg" role="dialog" aria-label="Marketing preferences">
    <div><strong>Help us understand what brings families to Bibow.</strong><p class="mb-0 small text-secondary">Allow optional marketing measurement. Booking still works if you decline.</p></div>
    <div class="d-flex gap-2 flex-shrink-0"><button class="btn btn-outline-secondary" onclick={() => choose('no')}>Not now</button><button class="btn btn-bibow" onclick={() => choose('yes')}>Allow</button></div>
  </div>
{/if}

{#if config?.enabled && config.messengerUrl}
  <a class="messenger-fab" href={config.messengerUrl} target="_blank" rel="noopener noreferrer" aria-label="Chat with Bibow on Messenger">
    <span aria-hidden="true">✦</span><span>Message Bibow</span>
  </a>
{/if}
